/**
 * CSS Prefix
 * MUST be in sync with CSS_PREFIX inside ./constants.ts for client side
 */
export const CSS_PREFIX = 'hlr__';

const CSS_PREFIX_WHITELIST_DATA_CARDS = [
  /.skyplayer-preview-container/,
  /.jw-preview/,
  /.jw-reset/,
  /.c-player-card/,
  /.svp-info-poster/,
  /.home-page/,
  /.sb-show-main/,
];

const CSS_PREFIX_WHITELIST_GLIDER = [/^.glider/, /.draggable/, /.drag/, /.disabled/];
const CSS_PREFIX_WHITELIST_MOTORI = [/.motor-sport/];

/** Place here classes defined from third-party s/css, for which we have no control */
const CSS_PREFIX_WHITELIST_HLROOM = [/.react-horizontal-scrolling-menu/];

export const CSS_PREFIXES_WHITELIST = [
  ...CSS_PREFIX_WHITELIST_MOTORI,
  ...CSS_PREFIX_WHITELIST_GLIDER,
  ...CSS_PREFIX_WHITELIST_DATA_CARDS,
  ...CSS_PREFIX_WHITELIST_HLROOM,
];
